module.exports = __webpack_public_path__ + "img/Philips.18019a38.jpg";